import { Loading } from '@farmshare/ui-components';
import { Box } from '@mui/material';
import { map, sumBy } from 'lodash';
import { useEffect } from 'react';

import { JobsByState } from '../../shared/jobs-by-state';
import { useProducerJobs } from '../use-producer-jobs';

interface ProducerJobDashboardProps {
  onCountChange?: (count: number) => void;
}

export function ProducerJobDashboard({
  onCountChange,
}: ProducerJobDashboardProps) {
  const { user, columns, buyerMode } = useProducerJobs();

  const totalCount = sumBy(
    columns.filter((col) => col.title !== 'Inactive'),
    (col) => col.count,
  );
  useEffect(() => {
    onCountChange?.(totalCount);
  }, [totalCount, onCountChange]);

  if (!user) return <Loading />;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        pb: 1,
      }}
    >
      {map(columns, (col) => (
        <JobsByState
          key={col.title}
          title={col.title}
          paletteKey={col.paletteKey}
          count={col.count}
          loading={col.loading}
          jobs={col.jobs}
          buyerId={buyerMode ? user._id : undefined}
          hideAttention={col.hideAttention}
          defaultExpanded={col.defaultExpanded}
          hasNextPage={col.hasNextPage}
          hasPreviousPage={col.hasPreviousPage}
          page={col.page}
          perPage={col.perPage}
          onPageChange={col.onPageChange}
        />
      ))}
    </Box>
  );
}
